import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DevoteeService } from './devotee.service';
import { CategoryList } from '../../interface/admin-table.interface';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private catagoryList = new BehaviorSubject<any>([]);
  private solverList = new BehaviorSubject<any>([]);
  private responderList = new BehaviorSubject<any>([]);

  public categoryList$  = this.catagoryList.asObservable();
  public solverList$ = this.solverList.asObservable();
  public responderList$ = this.responderList.asObservable();
  constructor(private _http:HttpClient, private _devoteeService:DevoteeService) {}

  // getCategoryList(): Observable<any[]>{
  //   return this.categoryList$;
  // }

  setCategoryListValue(value:any){
    this.catagoryList.next(value);
    
  }

  setResponderListValue(value:any){
    this.responderList.next(value);
  }
}
